<template>
    <keep-alive>
        <router-view :pe_startWatchPosition_f="pe_startWatchPosition_f" :pe_stopWatchPosition_f="pe_stopWatchPosition_f"/>
    </keep-alive>
</template>

<script>

    export default {
        name: "v_Ongoing_Missions",
        props:{
            pe_startWatchPosition_f:{
                type: Function,
                require: true
            },
            pe_stopWatchPosition_f:{
                type: Function,
                require: true
            }
        },
    }
</script>

<style scoped>

</style>